<template>
    <div id="map-container"></div>
</template>
  
<script>
export default {
    name: "TencentMap",
    props: {
        address: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            map: null,
            marker: null,
            geocoder: null,
            center: {lat: '', lng: ''},
        };
    },
    mounted() {
        this.initMap();
    },
    beforeDestroy() {
        if (this.map) {
            this.map.destroy(); // 销毁地图实例
        }
    },
    methods: {
        initMap() {
            this.geocoder = new TMap.service.Geocoder();
            this.geocoder.getLocation({ address: this.address }).then((result) => {
                this.center.lat = result.result.location.lat
                this.center.lng = result.result.location.lng

                if(this.center.lat && this.center.lng){
                    if (window.TMap) {
                        this.createMap();
                    } else {
                        window.initMap = this.createMap;
                    }
                }else {
                    this.$Message.error("请填写正确的详细地址");
                }
            });
        },
        createMap() {
            // 创建地图实例
            this.map = new TMap.Map("map-container", {
                center: new TMap.LatLng(this.center.lat, this.center.lng),
                zoom: 13,
                enableScrollWheel: true, // 允许鼠标滚轮缩放
            });

            // 添加标记
            this.addMarker(this.center);

            // 绑定地图事件
            this.map.on("click", (evt) => {
                this.addMarker(evt.latLng);
            });
        },
        addMarker(position) {
            this.$emit('child-to-parent', position);
            // 移除旧标记
            if (this.marker) {
                this.marker.setMap(null);
            }

            // 创建新标记
            this.marker = new TMap.MultiMarker({
                map: this.map,
                styles: {
                    "myStyle": new TMap.MarkerStyle({ 
                        "width": 25,
                        "height": 35,
                        "anchor": { x: 16, y: 32 }
                    }) 
                },
                geometries: [{
                    position: new TMap.LatLng(position.lat, position.lng),
                    "styleId": 'myStyle',
                }]
            });
        },
    },
};
</script>
  
<style scoped>
#map-container {
    width: 100%;
    height: 600px; /* 必须设置高度 */
}
</style>